<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>CONTENTS</span></p>
<p class="toc-text-A"><a href="#/Book1/cover">Dangerous Masquerade</a></p>
<p class="toc-text"><span><a href="#/Book1/section5">Chapter One</a></span></p>
<p class="toc-text"><span><a href="#/Book1/section6">Chapter Two</a></span></p>
<p class="toc-text"><span><a href="#/Book1/section7">Chapter Three</a></span></p>
<p class="toc-text"><span><span href="#/Book1/section8" title="Link target outside of Sample">Chapter Four</span></span></p>
<p class="toc-text"><span><span href="#/Book1/section9" title="Link target outside of Sample">Chapter Five</span></span></p>
<p class="toc-text"><span><span href="#/Book1/section10" title="Link target outside of Sample">Chapter Six</span></span></p>
<p class="toc-text"><span><span href="#/Book1/section11" title="Link target outside of Sample">Chapter Seven</span></span></p>
<p class="toc-text"><span><span href="#/Book1/section12" title="Link target outside of Sample">Chapter Eight</span></span></p>
<p class="toc-text"><span><span href="#/Book1/section13" title="Link target outside of Sample">Chapter Nine</span></span></p>
<p class="toc-text"><span><span href="#/Book1/section14" title="Link target outside of Sample">Chapter Ten</span></span></p>
<p class="toc-text-A1"><span href="#/Book2/cover" title="Link target outside of Sample">Northern Magic</span></p>
<p class="toc-text"><span><span href="#/Book2/section6" title="Link target outside of Sample">Chapter One</span></span></p>
<p class="toc-text"><span><span href="#/Book2/section7" title="Link target outside of Sample">Chapter Two</span></span></p>
<p class="toc-text"><span><span href="#/Book2/section8" title="Link target outside of Sample">Chapter Three</span></span></p>
<p class="toc-text"><span><span href="#/Book2/section9" title="Link target outside of Sample">Chapter Four</span></span></p>
<p class="toc-text"><span><span href="#/Book2/section10" title="Link target outside of Sample">Chapter Five</span></span></p>
<p class="toc-text"><span><span href="#/Book2/section11" title="Link target outside of Sample">Chapter Six</span></span></p>
<p class="toc-text"><span><span href="#/Book2/section12" title="Link target outside of Sample">Chapter Seven</span></span></p>
<p class="toc-text"><span><span href="#/Book2/section13" title="Link target outside of Sample">Chapter Eight</span></span></p>
<p class="toc-text"><span><span href="#/Book2/section14" title="Link target outside of Sample">Chapter Nine</span></span></p>
<p class="toc-text"><span><span href="#/Book2/section15" title="Link target outside of Sample">Chapter Ten</span></span></p>
<p class="toc-text-A1"><span href="#/Book3/cover" title="Link target outside of Sample">Sonora Sundown</span></p>
<p class="toc-text"><span><span href="#/Book3/section5" title="Link target outside of Sample">Chapter One</span></span></p>
<p class="toc-text"><span><span href="#/Book3/section6" title="Link target outside of Sample">Chapter Two</span></span></p>
<p class="toc-text"><span><span href="#/Book3/section7" title="Link target outside of Sample">Chapter Three</span></span></p>
<p class="toc-text"><span><span href="#/Book3/section8" title="Link target outside of Sample">Chapter Four</span></span></p>
<p class="toc-text"><span><span href="#/Book3/section9" title="Link target outside of Sample">Chapter Five</span></span></p>
<p class="toc-text"><span><span href="#/Book3/section10" title="Link target outside of Sample">Chapter Six</span></span></p>
<p class="toc-text"><span><span href="#/Book3/section11" title="Link target outside of Sample">Chapter Seven</span></span></p>
<p class="toc-text"><span><span href="#/Book3/section12" title="Link target outside of Sample">Chapter Eight</span></span></p>
<p class="toc-text"><span><span href="#/Book3/section13" title="Link target outside of Sample">Chapter Nine</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bundle_content.vue?6dff9467